import "./Solutions.scss";
import solution1 from "../../assets/solution1.png";
import solution2 from "../../assets/solution2.png";
import solution3 from "../../assets/solution3.png";

export default function Solutions() {
  return (
    <div id="security-section" className="solutions spacing">
      <h2>In-House Security Built to Protect Your Crypto</h2>
      <div className="cards">
        <div className="card">
          <div className="content">
            <h3>Two-Step Login Protection</h3>
            <p>
              Double-layered security to block unauthorized access and protect
              your assets.
            </p>
          </div>
          <img src={solution1} alt="error" />
        </div>
        <div className="card">
          <img src={solution2} alt="error" />
          <div className="content">
            <h3>Withdrawal Whitelisting</h3>
            <p>
              Only approved wallets can receive funds—no surprises, no mistakes.
            </p>
          </div>
        </div>
        <div className="card">
          <div className="content">
            <h3>Custom Access for Teams</h3>
            <p>
              Create multi-user setups with controlled access to protect your
              core account.
            </p>
          </div>
          <img src={solution3} alt="error" />
        </div>
      </div>
    </div>
  );
}
